import React, { useRef, useState, useEffect } from 'react'

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { AddIcon } from './formUtil';
import Param from '../store/param';
import Control from '../store/control';

/**
 * A form component for aligning a stump length based on click and adjustment of stump length.
 * @returns {JSX.Element} JSX element containing the form.
 */
const FormAlign_2 = () => {
  const align   = Param.Get('align');
  const setParam   = Param.Get('setParam');
  const setControl = Control.Get('setControl');
  const SetCameraFront  = Control.Get('SetCameraFront');

  useEffect(() => {
    SetCameraFront()
  }, []);

  /**
   * Handles the change of input values and updates the corresponding parameters.
   * @param {Object} e - The event object.
   */
  const handleValue = (e) => {
    setParam(s => {s.align[e.target.name] = Number(e.target.value)});
    
    if (e.target.name === 'stumpLength') {
      var temp = Math.floor((e.target.value+align.stumpLengthAdjust) / align.interval);
      setParam(s => {s.compress.line_no = temp});
    } else if (e.target.name === 'stumpLengthAdjust') {
      var temp = Math.floor((align.stumpLength+e.target.value) / align.interval);
      setParam(s => {s.compress.line_no = temp});
    }
  };

  return (
    <Grid container spacing={1} alignItems='center' justifyContent='center'>
      <TextField
        id='filled-number'
        name='stumpLength'
        label="Stump length based on click"
        type="number"
        defaultValue={align.stumpLength}
        value={Math.round(align.stumpLength)}
        fullWidth
        onChange={handleValue}
        onMouseOver={() => setControl(s => {s.explanationText = 'Stump length from ischial level'; s.explanationImg = ''})}
        onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
        InputProps={{
          endAdornment: <InputAdornment position="start">mm</InputAdornment>,
          // endAdornment: <AddIcon unit='mm' helptext='Stump length from ischial level'/>,
        }}
        InputLabelProps={{
          style: { color: '#fff' },
          shrink: true,
        }}
        variant='standard'
        inputProps={{
          style: {
            color: 'white',
            textAlign: 'left'
          }, 
          min:0, 
          max:1000,
          step:1
        }}
      />

      <TextField
        id='filled-number'
        name='stumpLengthAdjust'
        label="Stump length adjustment"
        type="number"
        defaultValue={align.stumpLengthAdjust}
        fullWidth
        onChange={handleValue}
        onMouseOver={() => setControl(s => {s.explanationText = 'Adjustment of stump length, the above value'; s.explanationImg = ''})}
        onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
        InputProps={{
          endAdornment: <InputAdornment position="start">mm</InputAdornment>,
          // endAdornment: <AddIcon unit='mm' helptext='Adjustment of stump length, the above value'/>,
        }}
        InputLabelProps={{
          style: { color: '#fff' },
          shrink: true,
        }}
        variant='standard'
        inputProps={{
          style: {
            color: 'white',
            textAlign: 'left'
          }, 
          min:-1000, 
          max:1000,
          step:1
        }}
      />

      <TextField
        id='filled-number'
        label="Final stump adjustment(Only display)"
        type="number"
        defaultValue={Math.round(align.stumpLength + align.stumpLengthAdjust)}
        value={Math.round(align.stumpLength + align.stumpLengthAdjust)}
        fullWidth
        // onChange={handleValue}
        onMouseOver={() => setControl(s => {s.explanationText = 'Final stump length'; s.explanationImg = ''})}
        onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
        InputProps={{
          endAdornment: <InputAdornment position="start">mm</InputAdornment>,
          //endAdornment: <AddIcon unit='mm' helptext='Final stump length'/>,
        }}
        InputLabelProps={{
          style: { color: '#fff' },
          shrink: true,
        }}
        variant='standard'
        inputProps={{
          style: {
            color: 'white',
            textAlign: 'left'
          }, 
          min:-1000, 
          max:1000,
          step:1
        }}
      />
    </Grid>
  );
}
export default FormAlign_2;
